'use client';

import React, { useEffect, useRef } from 'react';

const cards = [
  {
    tag: 'Deploy',
    title: 'About 10 days to live',
    body: 'ICP session, meeting definition, verified data build, and pitch-trained reps dialing your market inside two weeks.',
  },
  {
    tag: 'Prove',
    title: 'The motion before the org',
    body: 'Weekly full-funnel reporting shows exactly which segments and messages convert on the phone. That evidence de-risks every GTM hire you make after.',
  },
  {
    tag: 'Scale',
    title: 'One rep to a team, no rebuild',
    body: 'When the motion proves out, add reps on the same system. Many clients run hybrid: our reps for outbound volume, your closers on strategic accounts.',
  },
];

export default function WhyFitsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">Why this fits post-raise</div>
          <h2 className="heading-2 text-ink">Speed now. Structure later.</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards?.map((card, i) => (
            <div
              key={card?.tag}
              className="rev bg-white border border-line-color rounded-brand p-7"
              style={{ transitionDelay: `${i * 0.09}s` }}
            >
              <span className="block font-mono text-[11px] tracking-[0.18em] text-primary uppercase mb-3.5">
                {card?.tag}
              </span>
              <h3 className="heading-3 text-ink mb-3">{card?.title}</h3>
              <p className="text-[15px] text-muted-text leading-relaxed">{card?.body}</p>
            </div>
          ))}
        </div>

        <div className="rev gold-strip mt-8" style={{ transitionDelay: '0.27s' }}>
          <div>
            <b className="text-primary">The comparison your CFO will ask for:</b> one in-house SDR
            runs roughly $10,000 per month fully loaded before turnover risk. A dedicated CommandVA rep is about a third of that, month to month, live in days.
          </div>
        </div>
      </div>
    </section>
  );
}